<template>
  <v-container class="white-wrapper" fluid>
    <div class="config-title" style="max-width:25rem;margin:0 auto;">
      <router-link to="/config" class="back-icon">
        <v-btn icon large color="primary">
          <img class="back-svg" src="@/assets/icon/arrow(back).svg" />
        </v-btn>
      </router-link>
      <div class="text-h6 font-weight-bold">
        {{ $t('config.transHistory') }}
      </div>
    </div>
    <v-tabs
      v-model="selectedTab"
      color="primary"
      hide-slider
      fixed-tabs
      centered
      active-class="font-weight-bold"
    >
      <v-tab value="eth">
        Binance
      </v-tab>
      <v-tab value="erc20">
        BEP-20
      </v-tab>
    </v-tabs>
    <v-tabs-items
      style="max-width:25rem;margin:0 auto;padding: 0 1.3rem;"
      v-model="selectedTab"
    >
      <v-tab-item>
        <template v-if="list.length > 0">
          <template v-for="item in list">
            <v-card
              class="pa-3 my-3"
              :key="item.hash"
              outlined
              style="width:100%;font-size:0.9rem;"
              @click="onClickCard(item)"
            >
              <div class="d-flex justify-space-between">
                <div class="font-weight-bold primary--text">
                  <div>Block#{{ item.blockNumber }}</div>
                </div>
                <div class="font-gray font-weight-bold">
                  {{ item.sendtype }}
                </div>
              </div>
              <div class="ellipsis-item text-subtitle-2 mb-2">
                {{ item.hash }}
              </div>
              <div class="d-flex justify-space-between">
                <div class="label primary--text">From</div>
                <div class="ellipsis-item">{{ item.from }}</div>
              </div>
              <div class="d-flex justify-space-between">
                <div class="label primary--text">To</div>
                <div class="ellipsis-item">{{ item.to }}</div>
              </div>
              <div class="text-right mt-2 font-weight-bold">
                {{ item.value !== '0' ? item.value + ' ETH' : $t('txHistory.contractCall') }}
              </div>
            </v-card>
          </template>
          <div class="d-flex justify-center">
            <v-btn
              v-show="!noMore"
              @click="getMore"
              color="primary"
              class="font-weight-bold"
              text
            >
              {{ $t('history.more') }}
            </v-btn>
          </div>
        </template>
        <template v-else-if="!isLoading">
          <div class="d-flex justify-center align-center mt-5 font-gray">
            {{ $t('history.noHistory') }}
          </div>
        </template>
      </v-tab-item>
      <v-tab-item>
        <template v-if="list.length > 0">
          <template v-for="item in list">
            <v-card
              class="pa-3 my-3"
              :key="item.hash"
              style="width:100%;font-size:0.9rem;"
              outlined
              @click="onClickCard(item)"
            >
              <div class="d-flex justify-space-between">
                <div class="font-weight-bold primary--text">
                  <div>Block#{{ item.blockNumber }}</div>
                </div>
                <div class="font-gray font-weight-bold">
                  {{ item.sendtype }}
                </div>
              </div>
              <div class="ellipsis-item text-subtitle-2 mb-2">
                {{ item.hash }}
              </div>
              <div class="d-flex justify-space-between">
                <div class="label primary--text">From</div>
                <div class="ellipsis-item">{{ item.from }}</div>
              </div>
              <div class="d-flex justify-space-between">
                <div class="label primary--text">To</div>
                <div class="ellipsis-item">{{ item.to }}</div>
              </div>
              <div class="text-right mt-2 font-weight-bold">
                  <img style="position: relative;top: 4px;width:20px;" :src="imgSrc(item.tokenSymbol)" />                

                {{
                  item.value !== 0
                    ? item.value + ' ' + item.tokenSymbol
                    : $t('history.callContract')
                }}
              </div>
            </v-card>
          </template>
          <div class="d-flex justify-center">
            <v-btn
              v-show="!noMore"
              @click="getMore"
              color="primary"
              class="font-weight-bold"
              text
            >
              {{ $t('history.more') }}
            </v-btn>
          </div>
        </template>
        <template v-else-if="!isLoading">
          <div class="d-flex justify-center align-center mt-5 font-gray">
            {{ $t('history.noHistory') }}
          </div>
        </template>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog v-model="detailDialog" max-width="35rem">
      <v-card>
        <v-card-title>{{ $t('history.detail') }}</v-card-title>
        <v-card-text>
          <div class="row-item">
            <div class="row-label  primary--text">BlockNumber</div>
            <span class="black--text">#{{ selected.blockNumber }}</span>
          </div>
          <v-divider class="my-1"></v-divider>
          <div class="row-item">
            <div class="row-label primary--text">Hash</div>
            <span class="black--text">{{ selected.hash }}</span>
          </div>
          <v-divider class="my-1"></v-divider>
          <div class="row-item">
            <div class="row-label primary--text">From</div>
            <span class="black--text">{{ selected.from }}</span>
          </div>
          <v-divider class="my-1"></v-divider>
          <div class="row-item ">
            <div class="row-label primary--text">To</div>
            <span class="black--text">{{ selected.to }}</span>
          </div>
          <v-divider class="my-1"></v-divider>
          <div class="row-item">
            <div class="row-label primary--text">Date</div>
            <span class="black--text">
              {{
                $moment.unix(selected.timeStamp).format('YYYY-MM-DD HH:mm:ss')
              }}
            </span>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="detailDialog = false">
            {{ $t('history.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import BigNumber from 'bignumber.js'

export default {
  computed: {
    myWalletAddress() {
      return this.$store.getters.user.wallet_address
    },
    isLoading() {
      return this.$store.getters.loading
    }
  },
  data() {
    return {
      list: [],
      page: 1,
      noMore: false,
      selectedTab: 0,
      detailDialog: false,
      selected: {}
    }
  },
  created() {
    this.callApi()
    // console.log(this.myWalletAddress.toUpperCase())
  },
  watch: {
    selectedTab(val) {
      this.page = 1
      this.list = []
      this.noMore = false
      this.callApi()
    }
  },
  methods: {
    imgSrc(item) {
      let src
      try {
        src = require(`@/assets/svg/${item + '-logo.svg'}`)
      } catch (e) {
        try {
          src = require(`@/assets/svg/${item + '-logo.png'}`)
        } catch (e) {
          src = require(`@/assets/svg/ETH-logo.svg`)
        }
      }
      return src
    },
    callApi() {
      this.$store.commit('loading', true)
      const params = { walletAdress: this.myWalletAddress, page: this.page }
      if (this.selectedTab === 0) {
        this.$store
          .dispatch('getTxHistoryEth', params)
          .then((res) => {
            // console.log(res)
            if (
              res.data.status === '0' &&
              res.data.message === 'No transactions found'
            )
              this.noMore = true
            if (res.data.status === '1')
              this.list = this.list.concat(
                res.data.result.map((i) => {
                  const val = new BigNumber(i.value)
                  const deci = new BigNumber(10).pow(18)
                  const result = val.div(deci)
                  const fmt = {
                    prefix: '',
                    decimalSeparator: '.',
                    groupSeparator: ',',
                    groupSize: 3,
                    secondaryGroupSize: 0,
                    fractionGroupSeparator: ' ',
                    fractionGroupSize: 0,
                    suffix: ''
                  }
                  // console.log(i.from.toUpperCase())

                  return {
                    ...i,
                    value: result.toFormat(fmt),
                    sendtype:
                      i.from.toUpperCase() ===
                      this.myWalletAddress.toUpperCase()
                        ? 'OUT'
                        : 'IN'
                  }
                })
              )

            this.$store.commit('loading', false)
          })
          .catch((err) => {
            this.$store.dispatch('toast', {
              toast: true,
              toast_msg: this.$t('errorServer'),
              timeout: 2000
            })
            this.$store.commit('loading', false)
          })
      } else {
        this.$store
          .dispatch('getTxHistoryErc', params)
          .then((res) => {
            // console.log(res)
            if (
              res.data.status === '0' &&
              res.data.message === 'No transactions found'
            )
              this.noMore = true
            if (res.data.status === '1')
              this.list = this.list.concat(
                res.data.result.map((i) => {
                  const val = new BigNumber(i.value)
                  const deci = new BigNumber(10).pow(i.tokenDecimal)
                  const result = val.div(deci)
                  const fmt = {
                    prefix: '',
                    decimalSeparator: '.',
                    groupSeparator: ',',
                    groupSize: 3,
                    secondaryGroupSize: 0,
                    fractionGroupSeparator: ' ',
                    fractionGroupSize: 0,
                    suffix: ''
                  }
                  // console.log(result.toFormat(fmt))

                  return {
                    ...i,
                    value: result.toFormat(fmt),
                    sendtype:
                      i.from.toUpperCase() ===
                      this.myWalletAddress.toUpperCase()
                        ? 'OUT'
                        : 'IN'
                  }
                })
              )

            this.$store.commit('loading', false)
          })
          .catch((err) => {
            this.$store.dispatch('toast', {
              toast: true,
              toast_msg: this.$t('errorServer'),
              timeout: 2000
            })
            this.$store.commit('loading', false)
          })
      }
    },
    getMore() {
      this.page = this.page + 1
      this.callApi()
    },
    onChangeTab() {
      this.page = 1
      this.list = []
      this.callApi()
    },
    onClickCard(item) {
      this.selected = item
      this.detailDialog = true
    }
  }
}
</script>

<style lang="scss" scoped>
.ellipsis-item {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.label {
  width: 3rem;
  margin-right: 0.5rem;
}
.row-item {
  font-size: 0.85rem;
  display: flex;
  flex-direction: column;
}
.row-label {
  min-width: 3rem;
  font-weight: bold;
}
</style>
